module.exports = __webpack_public_path__ + "static/img/3.5caf550.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/1/sp/3.png
// module id = 7U9z
// module chunks = 0